import React, { Children, useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { Box, Button, Divider, Grid } from "@mui/material";
import { StyledButton } from "../../../../../../shared/components/buttons/custom-button";
import FormBuilder from "../../../../../../shared/components/form-builder/form-builder";
import {
  BuyerSellerDetails,
  buyerSellerDetails,
  INonCertifiedTrader,
  mapBuyerSellerDetailsApiResponseToInitialValues,
  mapPayload,
} from "../../../tc-models/tc-req-dto/tc-buyer-seller-details.req_dto";
import { buyerSellerDetailsService } from "../../../tc-service/buyer-seller-details.service";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import useNotification from "../../../../../../shared/hooks/useNotification";
import { useFormActions } from "../../../../../../shared/hooks/form-builder.hooks";
import { useApi } from "../../../../../../shared/hooks/useApi";
import { LoaderComponent } from "../../../../../../shared/components/loaders/page-loader";
import {
  TC_CREATE_ROUTE_CONFIG,
  TCAppConfig,
} from "../../../../../../shared/app-configs/tc-app-configs";
import { dtrackItService } from "../../../tc-service/dtrackit.service";
import { CustomButton } from "../../../../../../shared/components/buttons/buttons";
import ModalPopup from "../../../../../../shared/components/modals/custom-popup";
import RawMaterialInfo from "./non-certified-trader";
import { ITcProductRawMaterialInformation } from "../../../tc-models/tc-req-dto/tc-certified-product-details.req_dto";
import NonCertifiedTraderInfo from "./non-certified-trader";
import { useFormik } from "formik";
import { Utills } from "../../../../../../shared/app-configs/utilit";
import { useTransactionCertificateStore } from "../../../../../../store/transaction-certificates.store";
import { InnerButton } from "../../../../../../shared/components/buttons/floating-button-container";
import { RestrictedDataValidation } from "../../../../../../shared/utils/custom-validation.utils";

interface SellerCertifiedProductsProps {
  onNextTab: () => Promise<void>;
}

const TE_ID_PATTERN = /^TE-\d{8}$/;
const isNaValue = (value?: string | null) =>
  typeof value === "string" && value.trim().toLowerCase() === "na";

const hasRestrictedPlaceholder = (value?: string | null, allowNa = false) => {
  if (!value) return false;
  if (allowNa && isNaValue(value)) return false;
  return RestrictedDataValidation.isRestrictedData(value);
};

const SellerCertifiedProducts: React.FC<SellerCertifiedProductsProps> = ({
  onNextTab,
}) => {
  const searchApi = useApi();
  const { notify } = useNotification();
  const { TE_ID, formtype } = useParams<string>();
  const hasCreateTc: boolean = formtype === "create-tc";
  const hasSubmitTc: boolean = formtype === "submited-tc";
  const hasRejectedTc: boolean = formtype === "rejected-tc";
  const [countries, setCountries] = useState([]);
  const [states, setState] = useState([]);
  const [getBuyerStates, setBuyerStates] = useState([]);
  const [getSellerStates, setSellerStates] = useState([]);

  const [getBuyerName, setBuyerName] = useState("");
  const [getBuyingOnBehalfOfFlag, setBuyingOnBehalfOfFlag] = useState("Yes");

  const { loading, executeGet, setLoadingState, executePost } = useApi();
  const { isRestrictPopUpSave,setCountryCodes, setStates, getTCStandardGOTS, cbLicensingCode } =
    useTransactionCertificateStore();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [visible, setVisible] = useState({
    sellerTEId: true,
    sellerName: true,
    buyerSeacrhTEId: true,
    disableBuyerTEId: false,
    disableBuyerTEName: false,
    buyerSearchName: true,
    buyerTEIdLabel: true,
    sellerTEIdLabel: true,
  });
  const [disable, setDisable] = useState({
    sellerCountry: true,
    sellerState: true,
    buyerCountry: true,
    buyerState: true,
    sellerPostCode: true,
    buyerPostCode: true,
    sellerTown: true,
    buyerTown: true,
    buyerAddress1: true,
    sellerAddress1: true,
  });
  const [sellerScStandards, setSellerScStandards] = useState<string[]>([]);
  const [isBuyerTeCertifiedVisbile, setBuyerTeCertifiedVisbile] =
    useState<boolean>(true);
  const [initialValues, setInitialValues] =
    useState<BuyerSellerDetails>(buyerSellerDetails);
  const [isDataInitialized, setIsDataInitialized] = useState<boolean>(false);
  const nonCertifiedTraderDatas: INonCertifiedTrader[] = [];

  const [stepData, setStepData] = useState({
    nonCertifiedTrader: nonCertifiedTraderDatas,
  });
  const navigate = useNavigate();
  const { getCurrentFormValues, updateField } = useFormActions(
    "buyer-seller-products"
  );

  const setZustandInitialState = (initial?: any) => {
    const defalutState: any = initialValues;
    //set zustand state inital values
    Object.entries(initial ?? defalutState).forEach(([key, value]) => {
      updateField(key, value);
    });
  };

  const buyerSellerDetailsValidationSchema = Yup.object().shape({
    // Seller Details
    sellerLicenseNumber: Yup.string()
      .required("Seller Client Number is required")
      .max(50, "Maximum 50 Characters is allowed")
      .test("seller-client-placeholder", "Restricted placeholder values are not allowed", (value) => !hasRestrictedPlaceholder(value)),
    sellerCertifiedOrganizationName: Yup.string()
      .required("Seller Certified Organization Name is required")
      .max(100, "Maximum 100 Characters is allowed")
      .test("seller-cert-org-placeholder", "Restricted placeholder values are not allowed", (value) => !hasRestrictedPlaceholder(value)),
    sellerCountryOrArea: Yup.string().required(
      "Seller Country/Area is required"
    ).test("seller-country-placeholder", "Restricted placeholder values are not allowed", (value) => !hasRestrictedPlaceholder(value)),
    buyerLicenseNumber: Yup.string().nullable(),
      // .when([], {
      //   is: () => getTCStandardGOTS,
      //   then: (schema) => schema.required("Buyer Client Number is required"),
      //   otherwise: (schema) => schema.nullable(),
      // }),
    // buyerCertifiedOrganizationName: Yup.string()
    //   .required("Organzation Name is required"),
      // .when([], {
      //   is: () => getTCStandardGOTS,
      //   then: (schema) =>
      //     schema.required("Buyer Certified Organization Name is required"),
      //   otherwise: (schema) => schema.nullable(),
      // }),

    // sellingOnBehalfOfFlag: Yup.string()
    //   .when([], {
    //     is: () => !getTCStandardGOTS,
    //     then: (schema) =>
    //       schema.required("Selling On Behalf Of Flag is required"),
    //   })
    //   .max(1, "Maximum 1 Character is allowed"),

    sellerName: Yup.string()
      .required("Seller Name is required")
      .max(100, "Maximum 100 Characters allowed")
      .test("seller-name-placeholder", "Restricted placeholder values are not allowed", (value) => !hasRestrictedPlaceholder(value)),

    sellerTEId: Yup.string()
      .required("Seller TE ID is required")
      .matches(TE_ID_PATTERN, "Seller TE ID must match TE-########")
      .test(
        "sellerTEId-validation",
        "Custom Error: Seller TE ID must be different from Buyer TE ID",
        function (value) {
          const { buyerTEId } = this.parent;
          if (!value) return true;
          if (value === buyerTEId) {
            return this.createError({
              message: "Buyer TE ID must not be equal to Seller TE ID",
            });
          }
          return true;
        }
      ),

    sellerAddress1: Yup.string()
      .required("Seller Address Line 1 is required")
      .max(1000, "Maximum 1000 Characters is allowed")
      .test("seller-address-placeholder", "Restricted placeholder values are not allowed", (value) => !hasRestrictedPlaceholder(value)),

    sellerStateOrProvince: Yup.string()
      .required("Seller State/Province required")
      .test("seller-state-placeholder", "Restricted placeholder values are not allowed", (value) => !hasRestrictedPlaceholder(value)),

    sellerSCNumber: Yup.string()
      .required("Seller SC Number is required")
      .max(50, "Maximum 50 Characters is allowed"),

    // buyingOnBehalfOfFlag: Yup.string().when([], {
    //   is: () => !getTCStandardGOTS,
    //   then: (schema) => schema.required("Buying On Behalf Of Flag is required"),
    // }),

    buyerName: Yup.string()
      .required("Buyer Name is required")
      .max(100, "Maximum 100 Characters is allowed")
      .test("buyer-name-placeholder", "Restricted placeholder values are not allowed", (value) => !hasRestrictedPlaceholder(value)),

    buyerTEId: Yup.string()
      .required()
      .matches(TE_ID_PATTERN, "Buyer TE ID must match TE-########")
      .test(
        "buyerTEId-validation",
        "Custom Error: Buyer TE ID must be different from Seller TE ID",
        function (value) {
          const { sellerTEId } = this.parent;
          if (!value) return true;
          if (value === sellerTEId) {
            return this.createError({
              message: "Seller TE ID must not be equal to Buyer TE ID",
            });
          }
          return true;
        }
      ),

    buyerAddress1: Yup.string()
      .required("Buyer Address Line 1 is required")
      .max(1000, "Maximum 1000 Characters is allowed")
      .test("buyer-address-placeholder", "Restricted placeholder values are not allowed", (value) => !hasRestrictedPlaceholder(value)),

    buyerStateOrProvince: Yup.string()
      .required("Buyer State/Province is required")
      .test("buyer-state-placeholder", "Restricted placeholder values are not allowed", (value) => !hasRestrictedPlaceholder(value)),

    buyerCountryOrArea: Yup.string()
      .required("Buyer Country or Area is required")
      .test("buyer-country-placeholder", "Restricted placeholder values are not allowed", (value) => !hasRestrictedPlaceholder(value)),

    nonCertifiedTrader: Yup.array().of(
      Yup.object().shape({
        sellerNonCertifiedTraderName: Yup.string()
          .nullable()
          .required("Seller non-certified trader name is required; use na if not applicable")
          .max(255, "Maximum 255 Characters is allowed")
          .test('no-restricted-data', 'N/A, Not available, n/a are not allowed. Use "na" if not applicable',
            (value) => !hasRestrictedPlaceholder(value, true)),
        sellerNonCertifiedTraderTeId: Yup.string()
          .nullable()
          .test("noncert-teid-required", "Seller non-certified trader TE-ID is required when trader name is not na", function(value) {
            const traderName = this.parent?.sellerNonCertifiedTraderName;
            if (!traderName || isNaValue(traderName)) return true;
            return !!value;
          })
          .test("noncert-teid-format", "Seller non-certified trader TE-ID must match TE-########", (value) => {
            if (!value) return true;
            return TE_ID_PATTERN.test(value);
          }),
      })
    ).min(1, "Please add Non-Certified Trader Info"),
    buyerAddress2: Yup.string().nullable(), // Optional field
    buyerAddress3: Yup.string().nullable(), // Optional field
    buyerPostcode: Yup.string()
      .required("Buyer Postcode is required")
      .test('no-restricted-data', 'N/A, Not available, n/a are not allowed. Use "na" if not available', 
        (value) => {
          if (!value) return true; // Required check already handles empty values
          const trimmedValue = value.trim();
          if (trimmedValue.toLowerCase() === "na") return true;
          return !RestrictedDataValidation.isRestrictedData(value);
        }),
    buyerTown: Yup.string()
      .required("Buyer Town is required")
      .max(255, "Maximum 255 Characters is allowed")
      .test('no-restricted-data', 'N/A, Not available, n/a are not allowed. Use "na" if not available',
        (value) => !hasRestrictedPlaceholder(value, true)),
    // isBuyerTeCertified: Yup.string(),
    sellerNonCertifiedTraderName: Yup.string()
      .nullable()
      .test('no-restricted-data', 'N/A, Not available, n/a are not allowed. Use "na" if not applicable', 
        (value) => {
          if (!value) return true;
          const trimmedValue = value.trim();
          // Allow "na" as it's a valid value for "not applicable"
          if (trimmedValue === "na") return true;
          // Use the imported function to check for other restricted values
          return !RestrictedDataValidation.isRestrictedData(value);
        }),
    SellerNonCertifiedTraderTEId: Yup.string().nullable(), // Optional field
    sellerPostcode: Yup.string()
      .required("Seller Postcode is required")
      .test('no-restricted-data', 'N/A, Not available, n/a are not allowed. Use "na" if not available', 
        (value) => {
          if (!value) return true; // Required check already handles empty values
          const trimmedValue = value.trim();
          if (trimmedValue.toLowerCase() === "na") return true;
          return !RestrictedDataValidation.isRestrictedData(value);
        }),
    sellerTown: Yup.string()
      .required("Seller Town is required")
      .max(255, "Maximum 255 Characters is allowed")
      .test('no-restricted-data', 'N/A, Not available, n/a are not allowed. Use "na" if not available',
        (value) => !hasRestrictedPlaceholder(value, true)),
    tcSellerProductDeclarations: Yup.string().nullable(),
    buyerSCNumber: Yup.string()
      .required("Buyer SC Number is required")
      .max(50, "Maximum 50 Characters is allowed")
      .test('buyer-sc-placeholder', 'N/A, Not available, n/a are not allowed. Use "na" if not applicable',
        (value) => !hasRestrictedPlaceholder(value, true))
      .test(
        "unique-sc-number",
        "Buyer SC Number must be different from Seller SC Number",
        function(value) {
          const { sellerSCNumber } = this.parent;
          if (isNaValue(value)) return true;
          if (!value || !sellerSCNumber) return true;
          return value !== sellerSCNumber;
        }
      ),
    buyerCertifiedOrganizationName: Yup.string()
      .required("Buyer Certified Organization Name is required")
      .max(100, "Maximum 100 Characters is allowed")
      .test("buyer-cert-org-conditional", function(value) {
        const { buyerSCNumber } = this.parent;
        if (isNaValue(buyerSCNumber)) {
          if (!isNaValue(value)) {
            return this.createError({ message: 'Buyer Certified Organization Name must be "na" when Buyer SC Number is "na"' });
          }
          return true;
        }
        if (!value || value.trim() === "") {
          return this.createError({ message: "Buyer Certified Organization Name is required" });
        }
        if (hasRestrictedPlaceholder(value)) {
          return this.createError({ message: "Restricted placeholder values are not allowed" });
        }
        return true;
      }),
  });

  const fetchSCDetailsFromAPI = async (query: string, teId: string, dropDown: 'Buyer' | 'Seller') => {
    try {
      if (!teId || teId === "") {
        return [];
      }
      const response: any = await searchApi.executeGet(
        TCAppConfig.GET_BUYER_SELLER_SC_NO_V4,
        { 
          scNo: query, 
          scCbLicensingCode: cbLicensingCode,
          teId: teId,
          tcId: TE_ID,
          dropDown: dropDown
        }
      );
      
      const items = response.data.response || [];
      return items.map((item: any) => ({
        label: item.scNo,
        value: item.scNo,
        scNo: item.scNo,                    // Add for sellerSCValueChange
        certifiedOrganizationName: item.certifiedOrganizationName,
        scStandard: item.scStandard || []   // Add scStandard
      }));
    } catch (error) {
      console.error("Error fetching SC details:", error);
      return [];
    }
  };
  
  const handleSellerSCValueChange = (value: any) => {
    if (value == null) {
      formRef.current.setFieldValue("sellerSCNumber", "");
      formRef.current.setFieldValue("sellerCertifiedOrganizationName", "");
      setSellerScStandards([]); // Clear standards
    } else {
      const buyerSCNumber = formRef.current.values.buyerSCNumber;
      if (buyerSCNumber && (value.value === buyerSCNumber || value.scNo === buyerSCNumber)) {
        notify("Seller SC Number must be different from Buyer SC Number", "error");
        formRef.current.setFieldValue("sellerSCNumber", "");
        formRef.current.setFieldValue("sellerCertifiedOrganizationName", "");
        setSellerScStandards([]);
        return;
      }
      formRef.current.setFieldValue("sellerSCNumber", value.value || value.scNo);
      formRef.current.setFieldValue("sellerCertifiedOrganizationName", value.certifiedOrganizationName);
      setSellerScStandards(value.scStandard || []);
    }
  };
  
  const handleBuyerSCValueChange = (value: any) => {
    if (value == null) {
      formRef.current.setFieldValue("buyerSCNumber", "");
      formRef.current.setFieldValue("buyerCertifiedOrganizationName", "");
    } else {
      formRef.current.setFieldValue("buyerSCNumber", value.scNo);
      formRef.current.setFieldValue("buyerCertifiedOrganizationName", value.certifiedOrganizationName);
    }
  };

  useEffect(() => {
    const fetchTcBaseDetails = async () => {
      try {
        const response: any = await executeGet(
          TCAppConfig.GET_TC_BUYERSSELLERS_DETAILS_V4,
          { tcId: TE_ID }
        );
        if (response.data) {
          const apiData = response.data;
          
          // Map the API response to match your form structure
          const data: BuyerSellerDetails = {
            // Add tcId
            tcId: apiData.tcId || "",
            
            // Buyer fields
            buyerTEId: apiData.buyerInformation?.buyerTeId || "",
            buyerName: apiData.buyerInformation?.buyerName || "",
            buyerAddress1: apiData.buyerInformation?.buyerStreetAddress || "",
            buyerAddress2: apiData.buyerInformation?.buyerAddress2 || "",
            buyerAddress3: apiData.buyerInformation?.buyerAddress3 || "",
            buyerTown: apiData.buyerInformation?.buyerTown || "",
            buyerPostcode: apiData.buyerInformation?.buyerPostcode || "",
            buyerLicenseNumber: apiData.buyerInformation?.buyerCbClientNo || "",
            buyerStateOrProvince: apiData.buyerInformation?.buyerStateOrProvince || "",
            buyerCountryOrArea: apiData.buyerInformation?.buyerCountryOrArea || "",
            buyerCertifiedOrganizationName: apiData.buyerInformation?.buyerCertifiedOrganizationName || "",
            buyerSCNumber: apiData.buyerInformation?.buyerScNo || "",
            buyingOnBehalfOfFlag: apiData.buyerInformation?.buyingOnBehalfOfFlag || "Yes",
            isBuyerTeCertified: apiData.buyerInformation?.isBuyerTeCertified || "Yes",
            
            // Seller fields
            sellerTEId: apiData.sellerInformation?.sellerTeId || "",
            sellerName: apiData.sellerInformation?.sellerName || "",
            sellerAddress1: apiData.sellerInformation?.sellerStreetAddress || "",
            sellerAddress2: apiData.sellerInformation?.sellerAddress2 || "",
            sellerAddress3: apiData.sellerInformation?.sellerAddress3 || "",
            sellerTown: apiData.sellerInformation?.sellerTown || "",
            sellerPostcode: apiData.sellerInformation?.sellerPostcode || "",
            sellerLicenseNumber: apiData.sellerInformation?.sellerCbClientNo || "",
            sellerCountryOrArea: apiData.sellerInformation?.sellerCountryOrArea || "",
            sellerStateOrProvince: apiData.sellerInformation?.sellerStateOrProvince || "",
            tcSellerProductDeclarations: apiData.sellerInformation?.tcSellerProductDeclarations || "",
            sellerCertifiedOrganizationName: apiData.sellerInformation?.sellerCertifiedOrganizationName || "",
            sellerSCNumber: apiData.sellerInformation?.sellerScNo || "",
            sellingOnBehalfOfFlag: apiData.sellerInformation?.sellingOnBehalfOfFlag || "Yes",
            
            // Non-certified trader
            nonCertifiedTrader: apiData.sellerNonCertifiedTraderInformation || [],
          };
    
          // Store seller SC standards separately (not displayed but needed for payload)
          if (apiData.sellerInformation?.sellerScStandard) {
            setSellerScStandards(apiData.sellerInformation.sellerScStandard);
          }
    
          if (data.nonCertifiedTrader.length > 0) {
            setStepData({ nonCertifiedTrader: data.nonCertifiedTrader });
          }
    
          console.log("Mapped data:", data);
    
          // Update visibility flags
          if (data?.sellerTEId && data?.sellerTEId !== "") {
            setVisible((prev) => ({
              ...prev,
              sellerTEIdLabel: false,
            }));
          }
          
          if (data?.buyerName) {
            setBuyerName(data?.buyerName);
          }
          
          if (data?.buyerTEId && data?.buyerTEId !== "") {
            setVisible((prev) => ({
              ...prev,
              buyerTEIdLabel: false,
            }));
          }
    
          // Load states based on countries
          if (data?.buyerCountryOrArea) {
            await getState(data.buyerCountryOrArea, true);
          }
          
          if (data?.sellerCountryOrArea) {
            await getState(data.sellerCountryOrArea, false);
          }
    
          // Handle postcode disable states
          if (data?.buyerPostcode) {
            setDisable((prev) => ({ ...prev, buyerPostCode: true }));
          } else {
            setDisable((prev) => ({ ...prev, buyerPostCode: false }));
          }
    
          if (data?.sellerPostcode) {
            setDisable((prev) => ({ ...prev, sellerPostCode: true }));
          } else {
            setDisable((prev) => ({ ...prev, sellerPostCode: false }));
          }
    
          // Handle town disable states
          if (data?.sellerTown) {
            setDisable((prev) => ({ ...prev, sellerTown: true }));
          } else {
            setDisable((prev) => ({ ...prev, sellerTown: false }));
          }
    
          if (data?.buyerTown) {
            setDisable((prev) => ({ ...prev, buyerTown: true }));
          } else {
            setDisable((prev) => ({ ...prev, buyerTown: false }));
          }
    
          // Handle address disable states
          if (data?.sellerAddress1) {
            setDisable((prev) => ({ ...prev, sellerAddress1: true }));
          } else {
            setDisable((prev) => ({ ...prev, sellerAddress1: false }));
          }
    
          if (data?.buyerAddress1) {
            setDisable((prev) => ({ ...prev, buyerAddress1: true }));
          } else {
            setDisable((prev) => ({ ...prev, buyerAddress1: false }));
          }
    
          // Handle country and state disable states
          if (data?.buyerCountryOrArea) {
            setDisable((prev) => ({ ...prev, buyerCountry: true }));
          }
          
          if (data?.buyerStateOrProvince) {
            setDisable((prev) => ({ ...prev, buyerState: true }));
          }
    
          if (data?.sellerCountryOrArea) {
            setDisable((prev) => ({ ...prev, sellerCountry: true }));
          }
          
          if (data?.sellerStateOrProvince) {
            setDisable((prev) => ({ ...prev, sellerState: true }));
          }
    
          setInitialValues(data);
          setZustandInitialState(data);
          setIsDataInitialized(true);
        } else {
          setIsDataInitialized(true);
        }
      } catch (err) {
        console.error("Failed to fetch TC Base Details:", err);
        setIsDataInitialized(true);
      }
    };
    const getCountry = async () => {
      try {
        const result: any = await dtrackItService.getCountry();
        // Utills.cl(`getCountry result ${JSON.stringify(result)}`);
        const countries = result.data.map((t: any) => ({
          value: t.code_1,
          label: t.description_1 + " (" + t.code_1 + ")",
        }));
        // Utills.cl(`countries ${countries}`);
        setCountries(countries);
        setCountryCodes(countries);
        // Utills.cl(`getCountry ${countries}`)
      } catch (err) {
        Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
      }
    };
    getCountry();
    if (TE_ID) {
      fetchTcBaseDetails();
    } else {
      setZustandInitialState();
      setIsDataInitialized(true);
    }
    // //alert(typeof getTCStandard)
  }, []);

  const getState = async (buyersCountryOrArea: any, isBuyer: boolean) => {
    try {
      // alert(`buyersCountryOrArea ${buyersCountryOrArea}, isBuyer ${isBuyer}`)
      const result: any = await dtrackItService.getStateBasedonCountry(
        buyersCountryOrArea
      );
      const list = Array.isArray(result?.data) ? result.data : [];
      const states = list.map((t: any) => ({
        value: t.code_1,
        label: `${t.description_1} (${t.code_1})`,
      }));
      if (isBuyer) {
        setBuyerStates(states);
      } else {
        setSellerStates(states);
      }
      // keep local and global state stores in sync
      setState(states);
      setStates(states);
    } catch (err) {
      Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
    }
  };

  // Simulate API call for fetching options
  const fetchTEDetallsFromAPI = async (
    value: string,
    offset: number,
    type: string,
    name?: string
  ): Promise<any[]> => {
    try {
      const queryParams: Record<string, any> = {
        query_param: type == "query" ? value : "",
        offset: offset,
        name: type == "name" ? value : "",
      };
      // Fetch TE Details using the getTEDetails function
      const response = await buyerSellerDetailsService.getTEDetails(
        queryParams
      );
      const data = response.data;
      Utills.cl(
        `fetchTEDetallsFromAPI details, query ${JSON.stringify(
          queryParams
        )} response data ${JSON.stringify(data)}`
      );

      return data;
    } catch (error) {
      console.error("Error fetching TE details:", error);
      throw error; // Re-throw error to handle it in the calling code
    }
  };

  // Handle selection change from SearchInput
  const handleSellerTEIdValueChange = (value: any) => {
    // if (formRef.current.values.sellingOnBehalfOfFlag === "N") {
    //   formRef.current.setFieldValue(
    //     "sellerCertifiedOrganizationName",
    //     value == null ? "" : value.account_name
    //   );
    // }
    const fields = [
      "sellerAddress1",
      "sellerTown",
      "sellerPostcode",
      "sellerStateOrProvince",
      "sellerCountryOrArea",
      "sellerName",
      "sellerTEId",
      "sellerCertifiedOrganizationName"
    ];
    if (value == null) {
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });
      setDisable((prev) => ({
        ...prev,
        sellerState: true,
        sellerCountry: true,
        sellerPostCode: true,
        sellerTown: true,
      }));
      setVisible((prev) => ({
        ...prev,
        sellerName: true,
        sellerTEIdLabel: true,
      }));
    } else {
      // If buyer TE ID is already present and equal to the selected seller TE ID
      const currentBuyerTEId = formRef.current?.values?.buyerTEId;
      const selectedSellerTEId = value?.TE_ID ?? value?.TEID ?? value?.TEId ?? null;
      if (currentBuyerTEId && selectedSellerTEId && currentBuyerTEId === selectedSellerTEId) {
        notify("Buyer TE ID must not be equal to Seller TE ID", "error");
        // reset only the second-selected field (seller TE ID in this handler)
        fields.forEach((field) => {
          formRef.current.setFieldValue(field, "");
        });
        setDisable((prev) => ({
          ...prev,
          sellerState: true,
          sellerCountry: true,
          sellerPostCode: true,
          sellerTown: true,
        }));
        setVisible((prev) => ({
          ...prev,
          sellerName: true,
          sellerTEIdLabel: true,
        }));
        return;
      }
      formRef.current.setFieldValue("sellerName", value.account_name);
      formRef.current.setFieldValue("sellerTEId", value.TE_ID);
      // Reset SC Number and Certified Organization Name when TE ID changes
      formRef.current.setFieldValue("sellerSCNumber", "");
      formRef.current.setFieldValue("sellerCertifiedOrganizationName", "");
      setSellerScStandards([]);
      // formRef.current.setFieldValue("sellerAddress1", value.street);
      // formRef.current.setFieldValue("sellerTown", value.city);
      // formRef.current.setFieldValue("sellerPostcode", value.postal_code);
      if (
        value.country != null &&
        value.country != "" &&
        value.country != undefined
      ) {
        // Pass plain country code to getState; the service will normalize formatting for the API
        getState(value.country, false);
      }

      if (value.street == null) {
        setDisable((prev) => ({
          ...prev,
          sellerAddress1: false,
        }));
        formRef.current.setFieldValue("sellerAddress1", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerAddress1: true,
        }));
        formRef.current.setFieldValue("sellerAddress1", value.street);
      }

      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          sellerTown: false,
        }));
        formRef.current.setFieldValue("sellerTown", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerTown: true,
        }));
        formRef.current.setFieldValue("sellerTown", value.city);
      }

      if (value.postal_code == null) {
        setDisable((prev) => ({
          ...prev,
          sellerPostCode: false,
        }));
        formRef.current.setFieldValue("sellerPostcode", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerPostCode: true,
        }));
        formRef.current.setFieldValue("sellerPostcode", value.postal_code);
      }
      if (value.country == null) {
        setDisable((prev) => ({
          ...prev,
          sellerCountry: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerCountry: true,
        }));
        formRef.current.setFieldValue("sellerCountryOrArea", value.country);
      }

      if (value.state == null) {
        setDisable((prev) => ({
          ...prev,
          sellerState: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerState: true,
        }));
        formRef.current.setFieldValue("sellerStateOrProvince", value.state);
      }
      setVisible((prev) => ({
        ...prev,
        sellerName: false,
        sellerTEIdLabel: false,
      }));
    }
  };

  const handleSellerNamedValueChange = (value: any) => {
    // //alert(`form ${JSON.stringify(formRef.current.values)}`)
    // if (formRef.current.values.sellingOnBehalfOfFlag === "N") {
    //   formRef.current.setFieldValue(
    //     "sellerCertifiedOrganizationName",
    //     value == null ? "" : value.account_name
    //   );
    // }
    const fields = [
      "sellerAddress1",
      "sellerAddress2",
      "sellerAddress3",
      "sellerTown",
      "sellerPostcode",
      "sellerStateOrProvince",
      "sellerCountryOrArea",
      "sellerLicenseNumber",
      "sellerNonCertifiedTraderName",
      "sellerName",
      "sellerTEId",
      "sellerCertifiedOrganizationName"
    ];
    if (value == null) {
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });
      setDisable((prev) => ({
        ...prev,
        sellerState: true,
        sellerCountry: true,
        sellerPostCode: true,
        sellerTown: true,
      }));
      setVisible((prev) => ({
        ...prev,
        sellerTEId: true,
      }));
    } else {
      // Prevent selecting the same name as the buyer
      const currentBuyerName = formRef.current?.values?.buyerName;
      const selectedSellerName = value?.account_name ?? null;
      if (currentBuyerName && selectedSellerName && currentBuyerName === selectedSellerName) {
        notify("Seller Name must not be equal to Buyer Name", "error");
        // clear only the seller fields so user can re-select
        try {
          formRef.current.setFieldValue("sellerName", "");
          formRef.current.setFieldValue("sellerTEId", "");
          formRef.current.setFieldValue("sellerAddress1", "");
          formRef.current.setFieldValue("sellerTown", "");
          formRef.current.setFieldValue("sellerPostcode", "");
          formRef.current.setFieldValue("sellerStateOrProvince", "");
          formRef.current.setFieldValue("sellerCountryOrArea", "");
          formRef.current.setFieldValue("sellerCertifiedOrganizationName", "");
          try { updateField("sellerName", ""); updateField("sellerTEId", ""); } catch (e) {}
        } catch (e) {
          fields.forEach((field) => { formRef.current?.setFieldValue(field, ""); });
        }
        setDisable((prev) => ({
          ...prev,
          sellerState: true,
          sellerCountry: true,
          sellerPostCode: true,
          sellerTown: true,
        }));
        setVisible((prev) => ({
          ...prev,
          sellerTEId: true,
        }));
        return;
      }
      formRef.current.setFieldValue("sellerName", value.account_name);
      formRef.current.setFieldValue("sellerTEId", value.TE_ID);
      // Reset SC Number and Certified Organization Name when Seller Name changes
      formRef.current.setFieldValue("sellerSCNumber", "");
      formRef.current.setFieldValue("sellerCertifiedOrganizationName", "");
      setSellerScStandards([]);
      // formRef.current.setFieldValue("sellerAddress1", value.street);
      // formRef.current.setFieldValue("sellerTown", value.city);
      // formRef.current.setFieldValue("sellerPostcode", value.postal_code);
      if (
        value.country != null &&
        value.country != "" &&
        value.country != undefined
      ) {
        let countryCode = JSON.stringify(
          `[${[value.country].map((item) => `'${item}'`)}]`
        ).replace(/^"|"$/g, "");
        getState(countryCode, false);
      }

      if (value.street == null) {
        setDisable((prev) => ({
          ...prev,
          sellerAddress1: false,
        }));
        formRef.current.setFieldValue("sellerAddress1", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerAddress1: true,
        }));
        formRef.current.setFieldValue("sellerAddress1", value.street);
      }

      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          sellerTown: false,
        }));
        formRef.current.setFieldValue("sellerTown", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerTown: true,
        }));
        formRef.current.setFieldValue("sellerTown", value.city);
      }
      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          sellerTown: false,
        }));
        formRef.current.setFieldValue("sellerTown", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerTown: true,
        }));
        formRef.current.setFieldValue("sellerTown", value.city);
      }

      if (value.postal_code == null) {
        setDisable((prev) => ({
          ...prev,
          sellerPostCode: false,
        }));
        formRef.current.setFieldValue("sellerPostcode", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerPostCode: true,
        }));
        formRef.current.setFieldValue("sellerPostcode", value.postal_code);
      }
      if (value.country == null) {
        setDisable((prev) => ({
          ...prev,
          sellerCountry: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerCountry: true,
        }));
        formRef.current.setFieldValue("sellerCountryOrArea", value.country);
      }

      if (value.state == null) {
        setDisable((prev) => ({
          ...prev,
          sellerState: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerState: true,
        }));
        formRef.current.setFieldValue("sellerStateOrProvince", value.state);
      }
      setVisible((prev) => ({
        ...prev,
        sellerTEId: false,
      }));
    }
  };

  const handleBuyerTEIdValueChange = async (value: any) => {
    const fields = [
      "buyerAddress1",
      "buyerTown",
      "buyerPostcode",
      "buyerStateOrProvince",
      "buyerCountryOrArea",
      "buyerName",
      "buyerTEId",
    ];
    if (value == null) {
      setBuyerName("");
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });
      setVisible((prev) => ({
        ...prev,
        buyerSearchName: true,
      }));
      setVisible((prev) => ({
        ...prev,
        disableBuyerTEName: false,
        buyerTEIdLabel: true,
      }));
      setDisable((prev) => ({
        ...prev,
        buyerCountry: true,
        buyerState: true,
        buyerPostCode: true,
        buyerTown: true,
      }));
    } else {
      // If seller TE ID is already present and equal to the selected buyer TE ID
      const currentSellerTEId = formRef.current?.values?.sellerTEId;
      const selectedBuyerTEId = value?.TE_ID ?? value?.TEID ?? value?.TEId ?? null;
      if (currentSellerTEId && selectedBuyerTEId && currentSellerTEId === selectedBuyerTEId) {
        notify("Seller TE ID must not be equal to Buyer TE ID", "error");
        // reset only the second-selected field (buyer TE ID in this handler)
        fields.forEach((field) => {
          formRef.current.setFieldValue(field, "");
        });
        setVisible((prev) => ({
          ...prev,
          buyerSearchName: true,
        }));
        setVisible((prev) => ({
          ...prev,
          disableBuyerTEName: false,
          buyerTEIdLabel: true,
        }));
        setDisable((prev) => ({
          ...prev,
          buyerCountry: true,
          buyerState: true,
          buyerPostCode: true,
          buyerTown: true,
        }));
        return;
      }
      formRef.current.setFieldValue("buyerName", value.account_name);
      formRef.current.setFieldValue("buyerTEId", value.TE_ID);
      // Reset SC Number and Certified Organization Name when Buyer TE ID changes
      formRef.current.setFieldValue("buyerSCNumber", "");
      formRef.current.setFieldValue("buyerCertifiedOrganizationName", "");
      // formRef.current.setFieldValue("buyerAddress1", value.street);
      // formRef.current.setFieldValue("buyerPostcode", value.postal_code || "");
      setBuyerName(value.account_name);
      
      setVisible((prev) => ({
        ...prev,
        buyerSearchName: false,
        disableBuyerTEName: true,
        buyerTEIdLabel: false,
      }));
      if (getBuyingOnBehalfOfFlag == "N") {
        formRef.current.setFieldValue(
          "buyerCertifiedOrganizationName",
          value.account_name
        );
      }
      if (
        value.country != null &&
        value.country != "" &&
        value.country != undefined
      ) {
        let countryCode = JSON.stringify(
          `[${[value.country].map((item) => `'${item}'`)}]`
        ).replace(/^"|"$/g, "");
        await getState(countryCode, true);
      }
      if (value.street == null) {
        setDisable((prev) => ({
          ...prev,
          buyerAddress1: false,
        }));
        formRef.current.setFieldValue("buyerAddress1", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerAddress1: true,
        }));
        formRef.current.setFieldValue("buyerAddress1", value.street || "");
      }

      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          buyerTown: false,
        }));
        formRef.current.setFieldValue("buyerTown", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerTown: true,
        }));
        formRef.current.setFieldValue("buyerTown", value.city || "");
      }
      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          buyerTown: false,
        }));
        formRef.current.setFieldValue("buyerTown", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerTown: true,
        }));
        formRef.current.setFieldValue("buyerTown", value.city);
      }

      if (value.postal_code == null) {
        // alert("buyer postal code null")
        setDisable((prev) => ({
          ...prev,
          buyerPostCode: false,
        }));
        formRef.current.setFieldValue("buyerPostcode", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerPostCode: true,
        }));
        formRef.current.setFieldValue("buyerPostcode", value.postal_code);
      }

      if (value.country == null) {
        setDisable((prev) => ({
          ...prev,
          buyerCountry: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerCountry: true,
        }));
        formRef.current.setFieldValue("buyerCountryOrArea", value.country);
      }
      if (value.state == null) {
        setDisable((prev) => ({
          ...prev,
          buyerState: false,
        }));
        // //alert(disable.buyerState)
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerState: true,
        }));
        formRef.current.setFieldValue("buyerStateOrProvince", value.state);
      }
    }
  };

  const handleBuyerNameValueChange = (value: any) => {
    const fields = [
      "buyerAddress1",
      "buyerTown",
      "buyerPostcode",
      "buyerStateOrProvince",
      "buyerCountryOrArea",
      "buyerName",
      "buyerTEId",
    ];
    if (value == null) {
      setBuyerName("");
      if (getBuyingOnBehalfOfFlag == "N") {
        formRef.current.setFieldValue(
          "buyerCertifiedOrganizationName",
          ""
        );
      }
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });
      setVisible((prev) => ({
        ...prev,
        buyerSeacrhTEId: true,
        disableBuyerTEId: false,
        buyerTEIdLabel:true
      }));
      setDisable((prev) => ({
        ...prev,
        buyerCountry: true,
        buyerState: true,
        buyerPostCode: true,
        buyerTown: true,
      }));
    } else {
      // Prevent selecting the same name as the seller
      const currentSellerName = formRef.current?.values?.sellerName;
      const selectedBuyerName = value?.account_name ?? null;
      if (currentSellerName && selectedBuyerName && currentSellerName === selectedBuyerName) {
        notify("Buyer Name must not be equal to Seller Name", "error");
        // clear only buyer fields so user can re-select
        try {
          formRef.current.setFieldValue("buyerName", "");
          formRef.current.setFieldValue("buyerTEId", "");
          formRef.current.setFieldValue("buyerAddress1", "");
          formRef.current.setFieldValue("buyerTown", "");
          formRef.current.setFieldValue("buyerPostcode", "");
          formRef.current.setFieldValue("buyerStateOrProvince", "");
          formRef.current.setFieldValue("buyerCountryOrArea", "");
          formRef.current.setFieldValue("buyerSCNumber", "");
          formRef.current.setFieldValue("buyerCertifiedOrganizationName", "");
          try { updateField("buyerName", ""); updateField("buyerTEId", ""); } catch (e) {}
        } catch (e) {
          fields.forEach((field) => { formRef.current?.setFieldValue(field, ""); });
        }
        setVisible((prev) => ({
          ...prev,
          buyerSeacrhTEId: true,
          disableBuyerTEId: false,
          buyerTEIdLabel:true
        }));
        setDisable((prev) => ({
          ...prev,
          buyerCountry: true,
          buyerState: true,
          buyerPostCode: true,
          buyerTown: true,
        }));
        setBuyerName("");
        return;
      }
      formRef.current.setFieldValue("buyerName", value.account_name);
      formRef.current.setFieldValue("buyerAddress1", value.street);
      // Reset SC Number and Certified Organization Name when Buyer Name changes
      formRef.current.setFieldValue("buyerSCNumber", "");
      formRef.current.setFieldValue("buyerCertifiedOrganizationName", "");
      // formRef.current.setFieldValue("buyerTown", value.city || "");
      // formRef.current.setFieldValue("buyerPostcode", value.postal_code || "");
      setBuyerName(value?.account_name);
      if (getBuyingOnBehalfOfFlag == "N") {
        formRef.current.setFieldValue(
          "buyerCertifiedOrganizationName",
          value.account_name
        );
      }
      if (
        value.country != null &&
        value.country != "" &&
        value.country != undefined
      ) {
        let countryCode = JSON.stringify(
          `[${[value.country].map((item) => `'${item}'`)}]`
        ).replace(/^"|"$/g, "");
        getState(countryCode, true);
      }
  
      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          buyerTown: false,
        }));
        formRef.current.setFieldValue("buyerTown", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerTown: true,
        }));
        formRef.current.setFieldValue("buyerTown", value.city);
      }
  
      if (value.postal_code == null) {
        setDisable((prev) => ({
          ...prev,
          buyerPostCode: false,
        }));
        formRef.current.setFieldValue("buyerPostcode", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerPostCode: true,
        }));
        formRef.current.setFieldValue("buyerPostcode", value.postal_code);
      }
  
      if (value.country == null) {
        setDisable((prev) => ({
          ...prev,
          buyerCountry: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerCountry: true,
        }));
        formRef.current.setFieldValue("buyerCountryOrArea", value.country);
      }
  
      if (value.state == null) {
        setDisable((prev) => ({
          ...prev,
          buyerState: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerState: true,
        }));
        formRef.current.setFieldValue("buyerStateOrProvince", value.state);
      }
      setVisible((prev) => ({
        ...prev,
        buyerSeacrhTEId: false,
      }));
      setVisible((prev) => ({
        ...prev,
        disableBuyerTEId: true,
        buyerTEIdLabel:false
      }));
    }
  };

  const handleDataUpdate = (stepKey: string, updatedData: any) => {
    setStepData((prev) => ({
      ...prev,
      [stepKey]: updatedData,
    }));
  };
  // const testFOrmCOnfig = {
  //   pageName: "buyer-seller-products",
  //   initialValues,
  //   validationSchema: buyerSellerDetailsValidationSchema,
  //   sections: [
  //     {
  //       title: "Seller Details",
  //       fields: [
  //         {
  //           label: "testlink",
  //           name: "sellerTEId",
  //           type: "toggle",
  //           gridSize: { xs: 12, md: 4 },
  //           required: true,
  //           props: {
  //            children: <NavLink to="/test">Test</NavLink>
  //           },
  //         }
  //       ]
  //     }
  //   ],
  //   handleSubmit: async (values: any) => {
  //     try {

  //     } catch (error) {
  //       setLoadingState(false)
  //       console.error("Error saving Buyer & Seller Details:", error);
  //     }
  //   },
  // }
  const handleDialogOpen = () => {
    setDialogOpen(true);
    const zustandData = getCurrentFormValues();
    const nonCertifiedTrader =
      zustandData?.nonCertifiedTrader?.length > 0
        ? zustandData?.nonCertifiedTrader
        : [];
    setStepData({ nonCertifiedTrader: nonCertifiedTrader });
  };
  const formConfig = {
    pageName: "buyer-seller-products",
    initialValues,
    readOnly: hasSubmitTc,
    validationSchema: buyerSellerDetailsValidationSchema,
    sections: [
      {
        title: "Seller Information",
        fields: [
          // Row 1: Column 1 - TE-ID, Column 2 - Name, Column 3 - Street Address
          {
            label: "Seller TE-ID",
            name: "sellerTEId",
            type: "search",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.sellerTEId,
            visible: (value: any) => visible.sellerTEId,
            props: {
              placeholder: "Search Seller TE-ID",
              variant: "outlined",
              restrictInputFormat: visible.sellerTEIdLabel,
              param: "SellerTEId",
              onChange: handleSellerTEIdValueChange,
              displayKey: "TE_ID",
              onSearch: (query: string, offset: number) => {
                const response = fetchTEDetallsFromAPI(query, offset, "query");
                return response;
              },
              fullWidth: true,
            },
          },
          {
            label: "Seller TE-ID",
            name: "sellerTEId",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            disabled: true,
            visible: (value: any) => !visible.sellerTEId,
            props: {
              placeholder: "Enter Seller Name",
              fullWidth: true,
            },
          },
          {
            label: "Seller Name",
            name: "sellerName",
            type: "search",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.sellerName,
            visible: (value: any) => visible.sellerName,
            props: {
              placeholder: "Search Seller Name",
              variant: "outlined",
              onChange: handleSellerNamedValueChange,
              displayKey: "account_name",
              onSearch: (query: string, offset: number) => {
                Utills.cl(
                  `fetchTEDetallsFromAPI query ${query} offset ${offset}`
                );
                const response = fetchTEDetallsFromAPI(query, offset, "name");
                return response;
              },
              fullWidth: true,
            },
          },
          {
            label: "Seller Name",
            name: "sellerName",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            disabled: true,
            visible: (value: any) => !visible.sellerName,
            props: {
              placeholder: "Enter Seller Name",
              fullWidth: true,
            },
          },
          {
            label: "Seller Street Address",
            name: "sellerAddress1",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            disabled: disable.sellerAddress1,
            props: {
              placeholder: "Enter Seller Address",
              fullWidth: true,
            },
          },
          // Row 2: Column 1 - Town, Column 2 - Postcode, Column 3 - CB Client Number
          {
            label: "Seller Town",
            name: "sellerTown",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.sellerTown,
            disabled: disable.sellerTown,
            props: {
              placeholder: "Enter town",
              fullWidth: true,
            },
          },
          {
            label: "Seller Postcode",
            name: "sellerPostcode",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.sellerPostcode,
            disabled: disable.sellerPostCode,
            helperText: 'Please fill "na" if not available',
            props: {
              placeholder: "Enter postcode",
              fullWidth: true,
            },
          },
          {
            label: "Seller CB Client Number",
            name: "sellerLicenseNumber",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.sellerLicenseNumber,
            disabled: false,
            props: {
              placeholder: "Enter Seller Client Number",
              variant: "outlined",
              fullWidth: true,
            },
          },
          // Row 3: Column 1 - Country/Area, Column 2 - State/Province, Column 3 - Product Declarations
          {
            label: "Seller Country/Area",
            name: "sellerCountryOrArea",
            type: "select",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.sellerCountryOrArea,
            disabled: disable.sellerCountry,
            events: {
              onChange: (newValue: any, updatedValues: any) => {
                const code = Array.isArray(newValue) ? newValue[0] : newValue;
                getState(code, false);
              },
            },
            props: {
              enableSearch: true,
              options: countries,
              placeholder: "Seller Country/Area",
              fullWidth: true,
            },
          },
          {
            label: "Seller State/Province",
            name: "sellerStateOrProvince",
            type: "select",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.sellerStateOrProvince,
            disabled: disable.sellerState,
            props: {
              options: getSellerStates,
              enableSearch: true,
              placeholder: "Seller State/Province",
              fullWidth: true,
            },
          },
          {
            label: "TC Seller Product Declarations",
            name: "tcSellerProductDeclarations",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            value: initialValues.tcSellerProductDeclarations,
            disabled: false,
            props: {
              placeholder: "Enter the seller product declarations",
              fullWidth: true,
            },
          },
          // Row 4: Column 1 - SC Number, Column 2 - Certified Organization Name, Column 3 - Non-Certified Trader
          {
            label: "Seller SC Number",
            name: "sellerSCNumber",
            type: "search",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.sellerSCNumber,
            disabled: (values: any) => !values?.sellerTEId || values?.sellerTEId === "",
            props: {
              placeholder: "Search Seller SC Number",
              variant: "outlined",
              displayKey: "label",
              onChange: handleSellerSCValueChange,
              onSearch: (query: string) => {
                const sellerTEId = formRef.current?.values?.sellerTEId;
                if (!sellerTEId || sellerTEId === "") {
                  notify("Please select Seller TE ID first", "warning");
                  return Promise.resolve([]);
                }
                return fetchSCDetailsFromAPI(query, sellerTEId, 'Seller');
              },
              fullWidth: true,
            },
          },
          {
            label: "Seller Certified Organization Name",
            name: "sellerCertifiedOrganizationName",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            // readOnly: true,
            value: initialValues.sellerCertifiedOrganizationName,
            props: {
              placeholder: "Enter Certified Organization Name",
              variant: "outlined",
              fullWidth: true,
            },
          },
          {
            label: "",
            name: "nonCertifiedTrader",
            type: "component",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            children: (
              <>
                {" "}
                <CustomButton
                  sx={{
                    marginTop: "16px",
                    borderRadius: "30px",
                    padding: "10px 12px",
                    textTransform: "none",
                    backgroundColor: "#F0CD7F",
                    color: "#1C1C1C",
                    fontWeight: 400,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    "&:hover": {
                      backgroundColor: "#E0B86F",
                      color: "#000000",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
                    },
                  }}
                  onClick={handleDialogOpen}
                  variant="contained"
                  fullWidth
                  size="medium"
                  errorMessage=""
                  label={
                    stepData?.nonCertifiedTrader.length === 0 ? (
                      <>{hasSubmitTc ? "View" : "Add"} Non-Certified Trader Information</>
                    ) : (
                      <>{hasSubmitTc ? "View" : "Edit"} Non-Certified Trader Information</>
                    )
                  }
                />
                <span
                  style={{
                    fontSize: "0.8em",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {stepData?.nonCertifiedTrader.length} Records Added
                </span>
              </>
            ),
            props: {},
          },
        ],
      },
      {
        title: "Buyer Information",
        fields: [
          // {
          //   label: "Does the Buyer have a TE-ID?",
          //   name: "isBuyerTeCertified",
          //   type: "radio",
          //   gridSize: { xs: 12, md: 4 },
          //   required: false,
          //   value: initialValues.isBuyerTeCertified,
          //   events: {
          //     onChange: (value: any) => {
          //       Utills.cl("buyer te certified", value);
          //       if (value === "Yes") {
          //         formRef.current.setFieldValue("buyerStateOrProvince", "");
          //         formRef.current.setFieldValue("buyerCountryOrArea", "");
          //         formRef.current.setFieldValue("buyerTEId", "");
          //         formRef.current.setFieldValue("buyerName", "");
          //         formRef.current.setFieldValue("buyerAddress1", "");
          //         formRef.current.setFieldValue("buyerAddress2", "");
          //         formRef.current.setFieldValue("buyerAddress3", "");
          //         formRef.current.setFieldValue("buyerTown", "");
          //         formRef.current.setFieldValue("buyerPostcode", "");
          //         formRef.current.setFieldValue("buyerLicenseNumber", "");

          //         setBuyerTeCertifiedVisbile(true);
          //         setVisible((prev) => ({
          //           ...prev,
          //           buyerSearchName: true,
          //           buyerSeacrhTEId: true,
          //           disableBuyerTEId: true,
          //           disableBuyerTEName: true,
          //         }));
          //         setDisable((prev) => ({
          //           ...prev,
          //           buyerCountry: true,
          //           buyerState: true,
          //           buyerPostCode: true,
          //         }));
          //       } else {
          //         formRef.current.setFieldValue("buyerStateOrProvince", "");
          //         formRef.current.setFieldValue("buyerCountryOrArea", "");
          //         formRef.current.setFieldValue("buyerTEId", "");
          //         formRef.current.setFieldValue("buyerName", "");
          //         formRef.current.setFieldValue("buyerAddress1", "");
          //         formRef.current.setFieldValue("buyerAddress2", "");
          //         formRef.current.setFieldValue("buyerAddress3", "");
          //         formRef.current.setFieldValue("buyerTown", "");
          //         formRef.current.setFieldValue("buyerPostcode", "");
          //         formRef.current.setFieldValue("buyerLicenseNumber", "");
          //         setBuyerTeCertifiedVisbile(false);
          //         setVisible((prev) => ({
          //           ...prev,
          //           buyerSeacrhTEId: false,
          //           buyerSearchName: true,
          //           disableBuyerTEId: false,
          //           disableBuyerTEName: true,
          //         }));
          //         setDisable((prev) => ({
          //           ...prev,
          //           buyerCountry: false,
          //           buyerState: false,
          //           buyerPostCode: false,
          //         }));
          //       }
          //     },
          //   },
          //   props: {
          //     options: [
          //       { value: "Yes", label: "Yes" },
          //       { value: "N", label: "No" },
          //     ],
          //   },
          // },
          {
            label: "Is the Buyer certified?",
            name: "isBuyerTeCertified",
            type: "radio",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.isBuyerTeCertified || "Yes",
            events: {
              onChange: (value: any, formValues: any, setFieldValue: any) => {
                if (value === "No") {
                  setFieldValue("buyerSCNumber", "na");
                  setFieldValue("buyerCertifiedOrganizationName", "na");
                } else {
                  // Reset to default behavior for "Yes"
                  setFieldValue("buyerSCNumber", "");
                  setFieldValue("buyerCertifiedOrganizationName", "");
                }
              },
            },
            props: {
              options: [
                { value: "Yes", label: "Yes" },
                { value: "No", label: "No" },
              ],
            },
          },
          {
            label: "Buyer TE-ID",
            name: "buyerTEId",
            type: "search",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerTEId,
            visible: () => true,
            props: {
              placeholder: "Search Buyer TE-ID",
              variant: "outlined",
              displayKey: "TE_ID",
              restrictInputFormat: visible.buyerTEIdLabel,
              onChange: handleBuyerTEIdValueChange,
              onSearch: (query: string, offset: number) => {
                const response = fetchTEDetallsFromAPI(query, offset, "query");
                return response;
              },
              fullWidth: true,
            },
          },
          {
            label: "Buyer TE-ID",
            name: "buyerTEId",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            visible: () => false,
            props: {
              placeholder: "Enter Buyer TE-ID",
              fullWidth: true,
            },
          },
          // {
          //   label: "Buyer TE-ID",
          //   name: "buyerTEId",
          //   type: "text",
          //   gridSize: { xs: 12, md: 4 },
          //   required: false,
          //   visible: (values: any) => true,
          //   disabled: visible.disableBuyerTEId,
          //   props: {
          //     placeholder: "Enter Buyer TE ID",
          //     fullWidth: true,
          //   },
          // },
          {
            label: "Buyer Name",
            name: "buyerName",
            type: "search",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerName,
            visible: () => true,
            disabled: (values: any) =>
              !!(values?.buyerTEId && values?.sellerTEId && values?.buyerTEId === values?.sellerTEId),
            props: {
              placeholder: "Search Buyer Name",
              variant: "outlined",
              displayKey: "account_name",
              onChange: handleBuyerNameValueChange,
              onSearch: (query: string, offset: number) => {
                const response = fetchTEDetallsFromAPI(query, offset, "name");
                return response;
              },
              fullWidth: true,
            },
          },
          
          // ADD this new text field for Buyer Name when not certified:
          {
            label: "Buyer Name",
            name: "buyerName",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            visible: () => false,
            disabled: (values: any) =>
              !!(values?.buyerTEId && values?.sellerTEId && values?.buyerTEId === values?.sellerTEId),
            props: {
              placeholder: "Enter Buyer Name",
              fullWidth: true,
            },
          },
          // {
          //   label: "Legal Name of Buyer",
          //   name: "buyerName",
          //   type: "search",
          //   gridSize: { xs: 12, md: 4 },
          //   required: getTCStandardGOTS ? false : true,
          //   value: initialValues.buyerName,
          //   visible: (values: any) => true,
          //   props: {
          //     placeholder: "Search Buyer Name",
          //     variant: "outlined",
          //     displayKey: "account_name",
          //     onChange: handleBuyerNameValueChange,
          //     onSearch: (query: string, offset: number) => {
          //       const response = fetchTEDetallsFromAPI(query, offset, "name");
          //       return response;
          //     },
          //     fullWidth: true,
          //   },
          // },
          {
            label: "Buyer Street Address",
            name: "buyerAddress1",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerAddress1,
            disabled: (values: any) => {
              if (!disable.buyerAddress1) return false;
              return true;
            },
            props: {
              placeholder: "Enter Buyer Address",
              fullWidth: true,
            },
          },
          // {
          //   label: "Buyer Address 2",
          //   name: "buyerAddress2",
          //   type: "text",
          //   gridSize: { xs: 12, md: 4 },
          //   required: false,
          //   value: initialValues.buyerAddress2,
          //   disabled: (values: any) => values?.isBuyerTeCertified !== "N",
          //   props: {
          //     placeholder: "Enter Buyer Address 2",
          //     fullWidth: true,
          //   },
          // },
          // {
          //   label: "Buyer Address 3",
          //   name: "buyerAddress3",
          //   type: "text",
          //   gridSize: { xs: 12, md: 4 },
          //   required: false,
          //   value: initialValues.buyerAddress3,
          //   disabled: (values: any) => values?.isBuyerTeCertified !== "N",
          //   props: {
          //     placeholder: "Enter Buyer Address 3",
          //     fullWidth: true,
          //   },
          // },
          // Row 2: Column 1 - Town, Column 2 - Postcode, Column 3 - CB Client Number
          {
            label: "Buyer Town",
            name: "buyerTown",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerTown,
            disabled: (values: any) => {
              if (!disable.buyerTown) return false;
              return true;
            },
            props: {
              placeholder: "Enter town",
              fullWidth: true,
            },
          },
          {
            label: "Buyer Postcode",
            name: "buyerPostcode",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerPostcode,
            disabled: (values: any) => {
              if (!disable.buyerPostCode) return false;
              return true;
            },
            helperText: 'Please fill "na" if not available',
            props: {
              placeholder: "Enter postcode",
              fullWidth: true,
            },
          },
          {
            label: "Buyer CB Client Number",
            name: "buyerLicenseNumber",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            value: initialValues.buyerLicenseNumber,
            props: {
              placeholder: "Enter Buyer Client Number",
              variant: "outlined",
              fullWidth: true,
            },
          },
          // Row 3: Column 1 - Country/Area, Column 2 - State/Province, Column 3 - (empty)
          {
            label: "Buyer Country/Area",
            name: "buyerCountryOrArea",
            type: "select",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerCountryOrArea,
            disabled: (values: any) => {
              return disable.buyerCountry;
            },
            events: {
              onChange: (newValue: any, updatedValues: any) => {
                let countryCode = JSON.stringify(
                  `[${[newValue].map((item) => `'${item}'`)}]`
                ).replace(/^"|"$/g, "");
                getState(countryCode, true);
              },
            },
            props: {
              enableSearch: true,
              options: countries,
              placeholder: "Select Buyer Country/Area",
              fullWidth: true,
            },
          },
          {
            label: "Buyer State/Province",
            name: "buyerStateOrProvince",
            type: "select",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerStateOrProvince,
            disabled: (values: any) => disable.buyerState,
            props: {
              options: getBuyerStates,
              enableSearch: true,
              placeholder: "Select Buyer State/Province",
              fullWidth: true,
            },
          },
          // Row 4: Column 1 - SC Number, Column 2 - Certified Organization Name, Column 3 - (empty)
          {
            label: "Buyer SC Number",
            name: "buyerSCNumber",
            type: "search",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerSCNumber,
            visible: (values: any) => values?.isBuyerTeCertified !== "No",
            disabled: (values: any) => !values?.buyerTEId || values?.buyerTEId === "",
            props: {
              placeholder: "Search Buyer SC Number",
              variant: "outlined",
              displayKey: "label",
              onChange: (selected: any) => {
                if (selected) {
                  const sellerSCNumber = formRef.current.values.sellerSCNumber;
                  if (sellerSCNumber && (selected.value === sellerSCNumber || selected.scNo === sellerSCNumber)) {
                    notify("Buyer SC Number must be different from Seller SC Number", "error");
                    formRef.current.setFieldValue("buyerSCNumber", "");
                    formRef.current.setFieldValue("buyerCertifiedOrganizationName", "");
                    return;
                  }
                  formRef.current.setFieldValue("buyerSCNumber", selected.value || selected.scNo);
                  formRef.current.setFieldValue("buyerCertifiedOrganizationName", selected.certifiedOrganizationName || "");
                } else {
                  formRef.current.setFieldValue("buyerSCNumber", "");
                  formRef.current.setFieldValue("buyerCertifiedOrganizationName", "");
                }
              },
              onSearch: (query: string) => {
                const buyerTEId = formRef.current?.values?.buyerTEId;
                if (!buyerTEId || buyerTEId === "") {
                  notify("Please select Buyer TE ID first", "warning");
                  return Promise.resolve([]);
                }
                return fetchSCDetailsFromAPI(query, buyerTEId, 'Buyer');
              },
              fullWidth: true
            }
          },
          {
            label: "Buyer SC Number",
            name: "buyerSCNumber",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.buyerSCNumber,
            visible: (values: any) => values?.isBuyerTeCertified === "No",
            disabled: true,
            props: {
              placeholder: "na",
              fullWidth: true
            }
          },
          // {
          //   label: "Buying On Behalf Of Flag",
          //   name: "buyingOnBehalfOfFlag",
          //   type: "radio",
          //   gridSize: { xs: 12, md: 4 },
          //   required: (value: any) => {
          //     if (getTCStandardGOTS) {
          //       return false;
          //     }
          //     return value?.buyingOnBehalfOfFlag == "Yes";
          //   },
          //   value: initialValues.buyingOnBehalfOfFlag,
          //   events: {
          //     onChange: (value: any) => {
          //       setBuyingOnBehalfOfFlag(value);
          //       if (value === "Yes") {
          //         formRef.current.setFieldValue(
          //           "buyerCertifiedOrganizationName",
          //           ""
          //         );
          //       } else {
          //         formRef.current.setFieldValue(
          //           "buyerCertifiedOrganizationName",
          //           getBuyerName
          //         );
          //       }
          //     },
          //   },
          //   props: {
          //     options: [
          //       { value: "Yes", label: "Yes" },
          //       { value: "N", label: "No" },
          //     ],
          //   },
          // },
          {
            label: "Buyer Certified Organization Name",
            name: "buyerCertifiedOrganizationName",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            // readOnly: true,
            value: initialValues.buyerCertifiedOrganizationName,
            disabled: (values: any) => values?.isBuyerTeCertified === "No",
            props: {
              placeholder: "Enter Certified Organization Name",
              variant: "outlined",
              fullWidth: true
            },
          },
        ],
      },
    ],
    handleSubmit: async (values: any) => {
      // Save current form values before submission to restore on error
      const savedFormValues = formRef.current ? { ...formRef.current.values } : values;
      const savedZustandValues = getCurrentFormValues();
      
      const restoreFormValues = () => {
        // Restore from Zustand store first (delayed to ensure it happens after any Formik reset)
        setTimeout(() => {
          if (formRef.current && savedFormValues) {
            Object.keys(savedFormValues).forEach((key) => {
              formRef.current.setFieldValue(key, savedFormValues[key], false);
            });
          }
          // Also restore to Zustand store
          Object.keys(savedZustandValues).forEach((key) => {
            updateField(key, savedZustandValues[key]);
          });
        }, 100);
      };
      
      try {
        setLoadingState(true);
        const buyerSellerDatas = getCurrentFormValues();
        const payload = mapPayload(
          buyerSellerDatas,
          TE_ID,
          getBuyerStates,
          getSellerStates,
          sellerScStandards
        );

        Utills.cl("Buyer Seller Form Submitted:", JSON.stringify(payload), 2);

        const result: any = await executePost(
          TCAppConfig.POST_BUYER_SELLER_DETAILS_V4,
          payload
        );

        if (result?.status === 200) {
          notify("Saved Successfully", "success");

          // Use the tcId returned from API if available, otherwise fall back to route param
          const tcId = result.data?.tcId || TE_ID;

          // Let parent refresh completion map
          await onNextTab();

          // Navigate to next tab (Shipments) for create/edit flow
          if (!hasSubmitTc && tcId) {
            navigate(`/v4/tc/${formtype || "create-tc"}/shipment-details/${tcId}`);
          }
        } else if (result?.status === 400) {
          notify(result?.data?.Failed || "Unable to Save", "error");
          setLoadingState(false);
          restoreFormValues();
          return;
        } else {
          notify("Unable to Save", "error");
          setLoadingState(false);
          restoreFormValues();
          return;
        }
      } catch (error) {
        setLoadingState(false);
        console.error("Error saving Buyer & Seller Details:", error);
        notify("An error occurred while saving. Please try again.", "error");
        restoreFormValues();
        return;
      }
    },
  };

  // Ref to access the Formik instance in FormBuilder
  const formRef = useRef<any>(null);

  const handleSaveNonCertsTrader = async () => {
    if (stepData.nonCertifiedTrader.length === 0) {
      notify("Please add Non-Certified Trader Info", "error");
      return;
    }
    formRef.current.setFieldValue(
      "nonCertifiedTrader",
      stepData.nonCertifiedTrader
    );
    setDialogOpen(false);
    updateField("nonCertifiedTrader", stepData.nonCertifiedTrader);
    // setStepData({
    //   nonCertifiedTrader: nonCertifiedTraderDatas
    // })
  };

  const handleSubmit = async () => {
    try {
     if (hasSubmitTc) {
      navigate(`/v4/tc/${formtype}/shipment-details/${TE_ID}`);
    } else if (formRef.current) {
      formRef.current.submitForm(); // Programmatically submit the form
    }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      notify("Failed to save and navigate to next tab", "error");
    }
  }

  // const handleBack = () => {
  //     if (hasSubmitTc || hasRejectedTc) {
  //     // Navigate to previous tab in review mode
  //     navigate(`/v4/tc/${formtype}/base-details/${TE_ID}`);
  //   }
  // };

  return (
    <Box>
      {/* Render the FormBuilder component and pass formRef and onSubmit handler */}
      {loading || !isDataInitialized ? (
        <LoaderComponent />
      ) : (
        <>
          <FormBuilder
            formConfig={formConfig}
            onSubmit={formConfig.handleSubmit}
            formRef={formRef}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
              gap: "0.5rem"
            }}
          >
             <NavLink
              to={`/v4/tc-dashboard`}
            >
              <StyledButton variant="contained"   sx={{ boxShadow:"none" }}>
                 Home
              </StyledButton>
            </NavLink>
             <NavLink
              to={`/v4/tc/${formtype}/base-details/${TE_ID}`}
            >
              <StyledButton variant="contained"   sx={{ boxShadow:"none" }}>
                 Back
              </StyledButton>
            </NavLink>
            <StyledButton variant="contained"   sx={{ boxShadow:"none" }} onClick={handleSubmit}>
              {hasSubmitTc ? "Next" : "Save & Next"}
            </StyledButton>
          </Box>
        </>
      )}
      <ModalPopup
        open={dialogOpen}
        onSave={handleSaveNonCertsTrader}
        onClose={() => {
          setDialogOpen(false);
        }}
        disableSave = {isRestrictPopUpSave}
      >
        <NonCertifiedTraderInfo
          nonCertifiedInfoData={stepData.nonCertifiedTrader}
          setNonCertifiedInfoData={(data) =>
            handleDataUpdate("nonCertifiedTrader", data)
          }
        />
      </ModalPopup>
    </Box>
  );
};

export default SellerCertifiedProducts;
